import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { NotifyService } from 'src/app/shared/services/notify.service';
import { ProfessionalService } from 'src/app/shared/services/professional.service';
import { loadUnidade } from 'src/app/store/unidade/unidade.actions';
import {  selectUnitActiveList } from 'src/app/store/unidade/unidade.selectors';
@Component({
  selector: 'app-profissional-servico-form',
  templateUrl: './profissional-servico-form.component.html',
  styleUrls: ['./profissional-servico-form.component.scss']
})
export class ProfissionalServicoFormComponent implements OnInit {

  @Input() professionalId = 0;
  
  public formatoRepasse: boolean = false;
  especialidadeLista: any[] = []
  //unidadeLista$ = this.store.select(selectUnitActiveList);
  professionalUnits: any[] = []
  id: any = null;
  serviceId: any = null
  repasseTipoOptions: any[] = [{ label: '%', value: '%' }, { label: 'R$', value: 'R$' }];

  form = this.fb.group({
    professionalId: this.professionalId,
    serviceCode: this.fb.array([]),
    name: ['', [Validators.required]],
    units: [null as any, [Validators.required]],
    specialty: ['', [Validators.required]],
    age: [0],
    timeConsultant: [0 as any],
    observation: ['', []],
    color: ['0000ff', []],
    value: [null as any, [Validators.required]],
    valueType: ['R$'],
    payout: [null as any, Validators.required],
    totalPayout: [null as any],
    onlineSchedule: true,
  })

  constructor(
    private fb: FormBuilder, 
    private store: Store<any>, 
    private notify: NotifyService,
    private professionalService: ProfessionalService
  ) { }

  ngOnInit(): void {
    this.getProfessionalSpecialities()
    //this.store.dispatch(loadUnidade());
    this.form.controls['professionalId'].setValue(this.professionalId);
  }

  getProfessionalSpecialities(){
    //console.log('professional id: ', this.professionalId)
    this.professionalService.getById(this.professionalId).subscribe(res => {
      if(!res){
        return 
      }
      this.professionalUnits = res.units
      this.form.controls['units'].updateValueAndValidity()
      let professionalSpecialities = res.specialties
      
      this.especialidadeLista = professionalSpecialities

      if(professionalSpecialities.length == 1) {
        this.form.controls.specialty.setValue(professionalSpecialities[0]['@id'])
      }
    })
  }

  mudarFormaRepasse() {
    this.formatoRepasse = !this.formatoRepasse;

  }

  calculaTotalRepasseHandler() {
    const valor = this.form.value.value || 0;
    if (this.form.value.valueType == '%') {
      (this.form.get('payout') as any).setValue((this.form.value.payout / valor) * 100);
    } else {
      (this.form.get('payout') as any).setValue(valor * (this.form.value.payout / 100));
    }
    this.calculaTotalRepasse();
  }

  calculaTotalRepasse() {
    const valor = this.form.value.value || 0;
    let repasse = 0;
    let valorTotal = 0;
    if (this.form.value.payout && valor) {
      if (this.form.value.valueType == '%') {
        if (this.form.value.payout > 100) {
          this.notify.emitError('O valor de repasse não pode ser maior que o valor total')
          valorTotal = 0
        } else {
          valorTotal = (valor * (this.form.value.payout / 100))
        }
      } else {
        if (this.form.value.payout > valor) {
          this.notify.emitError('O valor de repasse não pode ser maior que o valor total')
          valorTotal = 0
        } else {
          valorTotal = this.form.value.payout;
        }
      }
    }
    this.form.controls['totalPayout'].setValue(valorTotal);
  }
  
  markAllAsDirty() {
    Object.keys(this.form.controls).forEach(key => {
      this.form.get(key)?.markAsDirty();
    });
  }

  public validateService() {
    let FormValue = this.form.value
    let isPayoutInvalid = FormValue.payout > FormValue.value

    if(FormValue.valueType == '%'){
      isPayoutInvalid = FormValue.payout > 100
    }

    if (this.especialidadeLista?.length) {
      return this.form.controls.name.invalid ||
        this.form.controls.value.invalid ||
        this.form.controls.payout.invalid ||
        this.form.controls.specialty.invalid ||
        this.form.controls.units.invalid ||
        isPayoutInvalid
    } else {
      return this.form.controls.name.invalid ||
        this.form.controls.value.invalid ||
        this.form.controls.payout.invalid ||
        this.form.controls.units.invalid ||
        isPayoutInvalid
    }
  }


/* mock */

stateOptions: any[] = [
  { label: '%', value: true },
  { label: 'R$', value: false },
];

}
